<template>
  <div v-if="track">
    <div class="download-track-name">
      ({{ track.track_number }}) {{ track.title }}
    </div>

    <div class="download-album-name text-stardust-grey">
      {{ track.album.name || track.description || track.composer }}
    </div>

    <p class="select-file-types-title">Select file type {{ fileTypeChosen }}</p>

    <div
      class="select-file-types-container"
      style="display: flex; gap: 15px; justify-content: center"
    >
      <a
        href="#"
        @click.prevent="fileTypeChosen = 'wav'"
        v-bind:class="{ active: fileTypeChosen == 'wav' }"
        class="file-type border border-stardust-grey"
      >
        <span class="file-type-text">WAV</span>
        <i class="material-icons active-icon">done</i>
      </a>
      <a
        href="#"
        @click.prevent="fileTypeChosen = 'mp3'"
        v-bind:class="{ active: fileTypeChosen == 'mp3' }"
        class="file-type border border-stardust-grey"
      >
        <span class="file-type-text">MP3</span>
        <i class="material-icons active-icon">done</i>
      </a>
      <a
        href="#"
        @click.prevent="fileTypeChosen = 'aiff'"
        v-bind:class="{ active: fileTypeChosen == 'aiff' }"
        class="file-type border border-stardust-grey"
      >
        <span class="file-type-text">AIFF</span>
        <i class="material-icons active-icon">done</i>
      </a>
    </div>

    <a
      href="#"
      class="btn btn-raised btn-danger btn-xl font-weight-semibold start-download-button"
      :class="{ disabled: downloadBtn.disabled }"
      @click="download($event)"
    >
      <span v-if="!downloadBtn.disabled">
        <template v-if="downloadBtn.loading">
          <img
            src="/images/download-spinner.gif"
            alt="spinner"
            class="loading-icon"
          />
          Preparing Download
        </template>
        <template v-if="!downloadBtn.loading">
          <i class="material-icons">done</i>&nbsp;Start Download
        </template>
      </span>
      <span v-if="downloadBtn.disabled">
        <i class="material-icons">error_outline</i>&nbsp;{{
          downloadBtn.status
        }}
      </span>
    </a>

    <div style="text-align: left; width: fit-content; margin: 20px auto">
      <div v-if="track.subtracks || parentSubtracks.length > 0">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            name="include_subtracks_check"
            id="include_subtracks_check"
            class="custom-control-input"
            value="1"
            v-model="includeSubtracks"
          />
          <label
            for="include_subtracks_check"
            class="custom-control-label select-file-types-title"
          >
            Include All Versions Of This Track
          </label>
        </div>
      </div>

      <div v-if="track.subtracks && !hasParentTrack" class="mt-4">
        <p v-for="subtrack in track.subtracks">
          {{ subtrack.title }}
        </p>
      </div>

      <div v-if="parentSubtracks.length > 0 && hasParentTrack" class="mt-4">
        <p v-if="parentTrackTitle">
          {{ parentTrackTitle }}
        </p>
        <p v-for="subtrack in parentSubtracks">
          {{ subtrack.title }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import Ladda from "ladda";

export default Vue.component("download-component", {
  data: function () {
    return {
      track: null,
      fileTypeChosen: window.authenticatedUserFileType,
      includeSubtracks: false,
      parentSubtracks: [],
      parentTrackTitle: "",
      subtrackChecking: 0,
      SubtrackCheckingStates: {
        CHECKING: 0,
        NO_SUBTRACKS: 1,
        HAS_SUBTRACKS: 2,
      },
      downloadBtn: {
        loading: false,
        disabled: false,
        status: "Failed",
      },
      guestDownload: false,
      hasParentTrack: false,
    };
  },

  computed: {
    AppBaseUrl() {
      return window.AppBaseUrl;
    },
  },

  watch: {
    track: function () {
      let ctx = this;

      // Change the button status to loading.
      this.downloadBtn.loading = true;
      this.downloadBtn.disabled = false;

      var ajaxUrl = "";

      if (this.guestDownload == true) {
        ajaxUrl = `${AppBaseUrl}/api/tracks/${this.track.id}/download-check?guest=true`;
      } else {
        ajaxUrl = `${AppBaseUrl}/api/tracks/${this.track.id}/download-check`;
        this.checkParentTracks();
        this.getParentTrack();
      }

      // Check if we're able to download.
      $.ajax({
        method: "GET",
        url: ajaxUrl,
        cache: false,
      })
        .done(function (response) {
          if (typeof response.data["subtrack_count"] !== "undefined") {
            let subtrackCount = parseInt(response.data["subtrack_count"]);

            if (subtrackCount > 0) {
              ctx.subtrackChecking = ctx.SubtrackCheckingStates.HAS_SUBTRACKS;
            } else {
              ctx.subtrackChecking = ctx.SubtrackCheckingStates.NO_SUBTRACKS;
            }
          }
        })
        .fail(function (responseData) {
          ctx.subtrackChecking = ctx.SubtrackCheckingStates.NO_SUBTRACKS;

          ctx.downloadBtn.disabled = true;

          if (typeof responseData.responseJSON.message !== "undefined") {
            ctx.downloadBtn.status = responseData.responseJSON.message;
          } else {
            ctx.downloadBtn.status = "Error preparing Download.";
          }
        })
        .always(function () {
          ctx.downloadBtn.loading = false;
        });
    },

    fileTypeChosen(newValue) {
      if (!newValue) {
        this.fileTypeChosen = "mp3";
      }
    },
  },

  mounted: function () {
    playerService.$on("user-updated", () => {
      this.fileTypeChosen = window.authenticatedUserFileType;
    });

    // Change the download modal contents depending on whats passed to it.
    playerService.$on("download-track", (track) => {
      this.track = null;

      this.reset();

      // Update curr track for modal.
      this.track = track;

      // Open the modal.
      window.webpackOpenBsModalWorkaround("#downloadTrackModal");
      this.guestDownload = false;
    });

    playerService.$on("download-track-as-guest", (track) => {
      this.track = null;

      this.reset();

      // Update curr track for modal.
      this.track = track;

      // Open the modal.
      window.webpackOpenBsModalWorkaround("#downloadTrackModal");
      this.guestDownload = true;
    });
  },

  methods: {
    reset() {
      this.fileTypeChosen = window.authenticatedUserFileType;

      if (!this.fileTypeChosen) {
        this.fileTypeChosen = "mp3";
      }

      this.includeSubtracks = false;
      this.subtrackChecking = this.SubtrackCheckingStates.CHECKING;
      this.downloadBtn = {
        loading: false,
        disabled: false,
        status: "Failed",
      };
    },

    download(event) {
      let ctx = this;

      if (this.includeSubtracks == true) {
        event.preventDefault();

        if (typeof ctx.track.subtracks == "undefined") {
          ctx.track.subtracks = [];
        }

        if (!this.track.subtracks) {
          $.ajax({
            method: "GET",
            url: `${AppBaseUrl}/api/tracks/getparenttrack/${this.track.id}`,
            cache: false,
          })
            .done(function (response) {
              ctx.track = response.data;

              // Use Download Resource for track and it's subtracks.
              playerService.downloadTrackCollection(
                "track-with-subtracks",
                ctx.track.id,
                ctx.fileTypeChosen,
                ctx.track.subtracks.length + 1,
              );
            })
            .fail(function (responseData) {
              ctx.downloadBtn.disabled = true;

              if (typeof responseData.responseJSON.message !== "undefined") {
                ctx.downloadBtn.status = responseData.responseJSON.message;
              } else {
                ctx.downloadBtn.status = "Error preparing Download.";
              }
            })
            .always(function () {
              ctx.downloadBtn.loading = false;
            });
        } else {
          // Use Download Resource for track and it's subtracks.
          playerService.downloadTrackCollection(
            "track-with-subtracks",
            ctx.track.id,
            ctx.fileTypeChosen,
            ctx.track.subtracks.length + 1,
          );
        }
      } else {
        playerService.downloadTrack(this.track.id, this.fileTypeChosen);
      }

      this.closeModal();
    },

    closeModal() {
      window.webpackCloseBsModalWorkaround("#downloadTrackModal");
    },

    getParentTrack() {
      let ctx = this;

      $.ajax({
        method: "GET",
        url: `${AppBaseUrl}/api/tracks/getparenttrack/${this.track.id}`,
        cache: false,
      })
        .done(function (response) {
          console.log(response);

          ctx.parentSubtracks = response.data.subtracks;
          ctx.parentTrackTitle = response.data.title;
        })
        .fail(function (responseData) {
          console.log(responseData);
        })
        .always(function () {
          console.log("");
        });
    },

    checkParentTracks() {
      let ctx = this;

      $.ajax({
        method: "GET",
        url: `${AppBaseUrl}/api/tracks/check-parent-tracks/${this.track.id}`,
        cache: false,
      })
        .done(function (response) {
          ctx.hasParentTrack = response.data;
        })
        .fail(function (responseData) {
          ctx.downloadBtn.disabled = true;

          if (typeof responseData.responseJSON.message !== "undefined") {
            ctx.downloadBtn.status = responseData.responseJSON.message;
          } else {
            ctx.downloadBtn.status = "Error preparing Download.";
          }
        })
        .always(function () {
          ctx.downloadBtn.loading = false;
        });
    },
  },
});
</script>
